import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { PRIVATE_NOTICE } from "@/constants/ingredients";

export default function Worlds() {
  const [worlds, setWorlds] = useState([]);
  useEffect(() => { api.get("/worlds").then((r) => setWorlds(r.data || [])); }, []);

  return (
    <div data-testid="worlds-page" className="section-pad">
      <div className="container-pp">
        <div className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Pop Panda Worlds</div>
        <h1 className="editorial-h1 text-5xl md:text-7xl mt-3 max-w-3xl">{worlds.length} worlds. One stick at a time.</h1>
        <p className="mt-6 max-w-2xl text-brand-charcoal/70 leading-relaxed">
          We don't show a fixed menu. We open a door. Step into the world that matches your mood —
          summer, comfort, indulgence, innovation or wellness — and discover the kind of pop made for it.
        </p>
        <div className="mt-6 max-w-2xl text-sm text-brand-charcoal/65 italic border-l-2 border-brand-red pl-4">{PRIVATE_NOTICE.long}</div>

        <div className="mt-16 grid md:grid-cols-2 gap-6">
          {worlds.map((w, i) => (
            <Link key={w.slug} to={`/worlds/${w.slug}`} data-testid={`worlds-card-${w.slug}`}
              className={`relative overflow-hidden rounded-3xl group h-[420px] flex flex-col justify-end p-8 ${w.dark ? "text-brand-cream" : "text-brand-charcoal"}`}>
              <div className="absolute inset-0">
                {w.hero && <img src={w.hero} alt={w.label} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />}
                <div className={`absolute inset-0 ${w.dark ? "bg-gradient-to-t from-brand-charcoal/85 to-brand-charcoal/10" : "bg-gradient-to-t from-brand-cream/85 to-brand-cream/0"}`} />
              </div>
              <div className="relative">
                <div className="text-[11px] uppercase tracking-[0.22em] opacity-80">0{i + 1} · {w.theme}</div>
                <div className="font-display text-4xl mt-2">{w.label}</div>
                <div className="font-display text-2xl mt-2 italic opacity-80">{w.headline}</div>
                <div className="mt-6 inline-flex items-center gap-2 text-sm font-medium">
                  {w.cta} <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
